import { render } from "./naverLoginComponentTest.vue?vue&type=template&id=30990c9e"
import script from "./naverLoginComponentTest.vue?vue&type=script&lang=js"
export * from "./naverLoginComponentTest.vue?vue&type=script&lang=js"

import exportComponent from "D:\\workspace\\eduwind-front\\eduwind-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__